class SlideshowVideo {
  constructor(container) {
    this.container = container;
    this.video = container.querySelector('video');
    if (!this.video) return;

    this.playButton = container.querySelector('[data-video-play-toggle]');
    this.muteButton = container.querySelector('[data-video-mute-toggle]');

    this.bindEvents();
    this.syncControls();
  }

  bindEvents() {
    if (this.playButton) {
      this.playButton.addEventListener('click', this.togglePlay.bind(this));
    }

    if (this.muteButton) {
      this.muteButton.addEventListener('click', this.toggleMute.bind(this));
    }

    this.video.addEventListener('play', this.syncControls.bind(this));
    this.video.addEventListener('pause', this.syncControls.bind(this));
    this.video.addEventListener('volumechange', this.syncControls.bind(this));
  }

  togglePlay(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  toggleMute(event) {
    event.preventDefault();
    event.stopPropagation();
    this.video.muted = !this.video.muted;
  }

  syncControls() {
    if (this.playButton) {
      const playIcon = this.playButton.querySelector('.slideshow-video__icon--play');
      const pauseIcon = this.playButton.querySelector('.slideshow-video__icon--pause');

      if (playIcon && pauseIcon) {
        playIcon.classList.toggle('hidden', !this.video.paused);
        pauseIcon.classList.toggle('hidden', this.video.paused);
      }
    }

    if (this.muteButton) {
      const unmuteIcon = this.muteButton.querySelector('.slideshow-video__icon--unmute');
      const muteIcon = this.muteButton.querySelector('.slideshow-video__icon--mute');

      if (unmuteIcon && muteIcon) {
        unmuteIcon.classList.toggle('hidden', this.video.muted);
        muteIcon.classList.toggle('hidden', !this.video.muted);
      }
    }
  }

  pause() {
    if (!this.video.paused) {
      this.video.pause();
    }
  }

  playIfAutoplay() {
    if (this.container.dataset.videoAutoplay === 'true' && this.video.paused) {
      const playPromise = this.video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }
  }
}

function initSlideshowVideos(root = document) {
  root.querySelectorAll('[data-slideshow-video]').forEach((container) => {
    if (!container.slideshowVideo) {
      container.slideshowVideo = new SlideshowVideo(container);
    }
  });
}

function pauseInactiveSlideshowVideos(slider) {
  if (!slider) return;

  const activeSlide = slider.querySelector('.slick-active');
  slider.querySelectorAll('[data-slideshow-video]').forEach((container) => {
    const instance = container.slideshowVideo;
    if (!instance) return;

    if (activeSlide && activeSlide.contains(container)) {
      instance.playIfAutoplay();
    } else {
      instance.pause();
    }
  });
}

function bindSlideshowVideoSliderEvents() {
  const sliders = document.querySelectorAll('.slider-custom .slider-item.slick-initialized');

  sliders.forEach((slider) => {
    if (slider.dataset.slideshowVideoBound === 'true') return;
    slider.dataset.slideshowVideoBound = 'true';

    if (typeof window.jQuery !== 'undefined') {
      window.jQuery(slider).on('afterChange', () => pauseInactiveSlideshowVideos(slider));
    }

    pauseInactiveSlideshowVideos(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initSlideshowVideos();
  bindSlideshowVideoSliderEvents();
});

document.addEventListener('shopify:section:load', (event) => {
  initSlideshowVideos(event.target);
  bindSlideshowVideoSliderEvents();
});

if (typeof window !== 'undefined') {
  window.initSlideshowVideos = initSlideshowVideos;
  window.bindSlideshowVideoSliderEvents = bindSlideshowVideoSliderEvents;
}
